import { createStyles, makeStyles, Typography, TypographyProps } from '@material-ui/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

const useStyles = makeStyles(() =>
    createStyles({
        h1: { fontSize: '9.33vw' },
        h2: { fontSize: '7vw' },
        h3: { fontSize: '5.46vw' },
        h4: { fontSize: '4.66vw' },
        h5: { fontSize: '4.02vw' },
        h6: { fontSize: '3.24vw' },
        body1: { fontSize: '4.02vw' },
        body2: { fontSize: '3.24vw' }
    })
);

interface Props {}

export const MobileTypography = forwardRef((props: Props & TypographyProps, ref) => {
    const classes = useStyles();
    return (
        <Typography
            {...props}
            className={clsx(props.className, {
                [classes.h1]: props.variant === 'h1',
                [classes.h2]: props.variant === 'h2',
                [classes.h3]: props.variant === 'h3',
                [classes.h4]: props.variant === 'h4',
                [classes.h5]: props.variant === 'h5',
                [classes.h6]: props.variant === 'h6',
                [classes.body2]: props.variant === 'body2',
                [classes.body1]: !props.variant
            })}
            innerRef={ref}
        />
    );
});
